import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import { store } from "./store"
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import '@/assets/sass/main.scss'
Vue.config.productionTip = true;
Vue.config.performance = false;

/* import VueHighlightJS from 'vue-highlightjs'
Vue.use(VueHighlightJS) */

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');

router.beforeEach((to, from, next) => {
  store.commit('showLoader', from);
  store.commit('setHistory', from);
  next();
});

router.afterEach((to, from) => {
  store.commit('hideLoader', from);
});

